import { Component, Input, OnChanges } from '@angular/core';
import qrEncoder from 'pdfmake/src/qrEnc.js';

type QrRect = {
  type: 'rect';
  x: number;
  y: number;
  w: number;
  h: number;
  color: string;
  lineWidth: number;
};

@Component({
  selector: 'app-qr-code-preview',
  templateUrl: './qr-code-preview.component.html',
  styleUrls: ['./qr-code-preview.component.scss']
})
export class QrCodePreviewComponent implements OnChanges {
  @Input() data: string | null = null;
  @Input() size = 192;
  @Input() padding = 4;
  @Input() foreground = '#111111';
  @Input() background = '#ffffff';
  @Input() eccLevel: 'L' | 'M' | 'Q' | 'H' = 'H';
  @Input() ariaLabel = 'QR code';

  public cells: QrRect[] = [];
  public qrSize = 0;

  public ngOnChanges(): void {
    const value = this.data?.trim();
    if (!value) {
      this.cells = [];
      this.qrSize = 0;
      return;
    }

    const node = qrEncoder.measure({
      qr: value,
      fit: this.size,
      padding: this.padding,
      foreground: this.foreground,
      background: this.background,
      eccLevel: this.eccLevel
    });

    this.cells = node._canvas ?? [];
    this.qrSize = node._width ?? this.size;
  }

  public trackByIndex(index: number): number {
    return index;
  }
}
